<template>
  <div class="navContent">
    <ul
      class="tgList"
      v-if="specialList.length>0"
    >
      <li
        v-for="(itm,index) in specialList"
        :key="index"
        @click="getZhuantiContent('zhuanti', itm.id, itm.html)"
      >
        <div class="tgListLeft">
          <h1 v-if="itm.subjectTag=='语'">
            <i class="tgYuwen">语</i>
            <span v-text="itm.name"></span>
          </h1>
          <h1 v-else-if="itm.subjectTag=='数'">
            <i class="tgShuxue">数</i>
            <span v-text="itm.name"></span>
          </h1>
          <h1 v-else-if="itm.subjectTag=='英'">
            <i class="tgYingyu">英</i>
            <span v-text="itm.name"></span>
          </h1>
          <h1 v-else-if="itm.subjectTag=='物'">
            <i class="tgWuli">物</i>
            <span v-text="itm.name"></span>
          </h1>
          <h1 v-else>
            <i class="tgYuwen">{{itm.subjectTag}}</i>
            <span v-text="itm.name"></span>
          </h1>
          <h2
            v-if="itm.secondName!=undefined"
            v-html="itm.secondName.length>26?itm.secondName.substring(0,26)+'...':itm.secondName"
          ></h2>
        </div>
        <div class="tgListRight">
          <img :src="contentHost+itm.coverImageSmall" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
import { baseUrl } from '@/assets/js/api'
export default {
    name: 'Special',
    props: {
        specialParams: {
            type: Object,
            default () {
                return {
                    gradeId: 2,
                    phaseId: 2,
                    subjectMap: { "1": 2, "2": 2, "3": 32 },
                    version: 2,
                }
            }
        },
        lessonId: {
            type: String,
            default(){
                return ''
            }
        },
    },
    data () {
        return {
            contentHost: '',
            specialList: []
        }
    },
    created () {

    },
    mounted () {
        let { gradeId, phaseId, subjectMap } = this.specialParams
        this.getSpecialList(gradeId, phaseId, subjectMap)
    },
    computed: {

    },
    methods: {
        getSpecialList (gradeId, phaseId, subjectMap) {
            var that = this;
            that.$parent.loading = true;
            var url = baseUrl + '/ures/resource/prelearn/getZhuantiList';

            this.$axios.get(url, {
                params: {
                    gradeId,
                    phaseId,
                    subjectMap,
                    version: 2
                }
            }).then(function (res) {
                let { msg, value } = res.data;
                if (res && msg === 'success') {
                    that.contentHost = value.host;
                    that.specialList = value.zhuantiList;
                    that.$parent.loading = false;
                    if(that.$parent.isInit) {
                        that.$nextTick(() => {
                            document.documentElement.scrollTop = that.$parent.scrollTop || 0;
                            document.body.scrollTop = that.$parent.scrollTop || 0;
                            that.$parent.isInit = false;
                        })
                    }
                }
            }).catch(function (err) {
                //vant.Toast(that.msg);
            });
        },
        getZhuantiContent (name, id, html) {
            if (html) {
                window.location.href = this.contentHost + html;
            } else {
                this.$router.push({
                    name: 'SpecialContent',
                    query: { params: paramsHelper.encode({ id, name, gradeId: this.specialParams.gradeId }),lessonId:this.lessonId }
                })
            }
        }
    }
}
</script>

<style scope lang="less">
.special {
}
</style>
